import React from "react";
import { PieChart, Pie, Cell, ResponsiveContainer } from "recharts";
import _ from "lodash";

interface ProgressMeterProps {
  data: any[];
}
const ProgressMeter: React.FC<ProgressMeterProps> = ({ data }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          cx="50%"
          cy="90%"
          startAngle={180}
          endAngle={0}
          innerRadius={55}
          outerRadius={70}
          dataKey="value"
          stroke="#ffffff"
        >
            {_.size(data) > 0 
            ? data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.fill} />
              ))
            : null}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ProgressMeter;
